/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Name_LabelInputs */

const en_company_profile_name_label = /** @type {(inputs: Company_Profile_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name of the company`)
};

const de_company_profile_name_label = /** @type {(inputs: Company_Profile_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Unternehmens`)
};

/**
* | output |
* | --- |
* | "Name of the company" |
*
* @param {Company_Profile_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_name_label = /** @type {((inputs?: Company_Profile_Name_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Name_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_name_label(inputs)
	return en_company_profile_name_label(inputs)
});